import React, { useEffect, useMemo, useState } from 'react';
import { Countdown } from '@marty-js/design/src/molecules/download/countdown';
import { DownloadFinished } from '@marty-js/design/src/molecules/download/download-finished';
import { DownloadButton } from '@marty-js/design/src/molecules/download/download-button';
import { useLinkComponent } from '@marty-js/design/src/utils/component';
import { useRouter } from 'next/router';
import { Ad } from '../../../../ads/ad';
import { useMetaSeoContext } from '../../../../utils/metaSeoContext';
import type { DownloadItemProps } from './types';

const StartDownload = ({
  item,
  file,
  set0verrideAdUnit,
  data,
  handlerRedirectLink,
  thumbnailOs,
}: DownloadItemProps & { thumbnailOs: { [key: string]: any }; handlerRedirectLink: any }) => {
  const metaSeoContext = useMetaSeoContext();
  const [urlRedirect, setUrlRedirect] = useState<string>(null);
  const router = useRouter();
  metaSeoContext.robots = 'noindex, nofollow';
  const adUnit = 'telechargement-start-rjs';

  useMemo(() => set0verrideAdUnit(adUnit), [set0verrideAdUnit]);

  useEffect(() => {
    const rand = Math.floor(Math.random() * 100);
    let count = 0;
    data.startDownloadRedirection?.data?.data?.data?.forEach((val) => {
      count += val.ratio;
      if (count >= rand) {
        count = -100;
        setInterval(() => setUrlRedirect(val.url), 30000);
      }
    });
  }, [setUrlRedirect, data.startDownloadRedirection, set0verrideAdUnit]);

  useEffect(() => {
    if (urlRedirect) {
      window.location.href = urlRedirect;
    }
  }, [urlRedirect, router]);

  const LinkComponent = useLinkComponent();

  return (
    <>
      {file.externalLinkOnly ? (
        <>
          <LinkComponent href={file.url} openInNewWindow>
            <DownloadButton
              isLoading={false}
              os={file.os}
              fileId={file.id}
              callback={handlerRedirectLink}
              thumbnailsOs={thumbnailOs}
            />
          </LinkComponent>
          <br />
        </>
      ) : (
        <>
          <DownloadFinished file={file} name={item.title} />
          <Countdown url={file.url} seconds={5} />
        </>
      )}
      <Ad className="Content_1 Mobile_Pos1" adUnitCondition={adUnit} />
    </>
  );
};

export default StartDownload;
